<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/standards" class="footer-link">Academic Standards</router-link>
        <span class="footer-divider">•</span>
        <router-link to="/terms" class="footer-link">Terms of Service</router-link>
        <span class="footer-divider">•</span>
        <router-link to="/privacy" class="footer-link">Privacy Policy</router-link>
      </div>
      <p class="footer-copyright">© 2025 ChalkboardAI. All rights reserved.</p>
    </div>
  </footer>
</template>

<script setup>
// No props or logic needed - just a simple static footer
</script>

<style scoped>
.app-footer {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem 1rem;
  margin-top: auto;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.footer-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

.footer-link:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  text-decoration: underline;
}

.footer-divider {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
}

.footer-copyright {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-footer {
    padding: 1.5rem 1rem;
  }

  .footer-links {
    flex-direction: column;
    gap: 0.5rem;
  }

  .footer-divider {
    display: none;
  }

  .footer-link {
    padding: 0.5rem 1rem;
  }
}
</style>

